import { useEffect } from "react";
import dayjs from "dayjs";

export const useTaskAddLogic = (
  taskTypeId: string,
  allTaskTypesFull: any[] | undefined,
  setTaskTypeRecord: (record: any) => void
) => {
  useEffect(() => {
    if (taskTypeId) {
      const selectedTaskType = allTaskTypesFull?.find((task) => task.id === taskTypeId);
      setTaskTypeRecord(selectedTaskType);
    }
  }, [taskTypeId, allTaskTypesFull, setTaskTypeRecord]);

  const getRoundedDate = (minutes: number, d = new Date()) => {
    let ms = 1000 * 60 * minutes; // convert minutes to ms
    let roundedDate = new Date(Math.round(d.getTime() / ms) * ms);
    return roundedDate;
  };

  const calculateEndTime = (startTime: string): string => {
    const [hours, minutes] = startTime.split(':').map(Number);
    return dayjs().hour(hours).minute(minutes).add(1, 'hour').format("HH:mm");
  };

  return {
    getRoundedDate,
    calculateEndTime,
  };
};
